export default "__VITE_ASSET__fGPXALdxBki0u1HmT0DvuQ__"